import apiClient from './apiClient';

export const getAdminStats = async () => {
  const { data } = await apiClient.get('/api/admin/stats');
  return data;
};

export const getAllSubscriptionPayments = async () => {
  const { data } = await apiClient.get('/api/admin/payments/subscriptions');
  return data;
};

export const getAllCoursePurchases = async () => {
  const { data } = await apiClient.get('/api/admin/payments/courses');
  return data;
};

